/// <reference types="vite/client" />

const gateway =
  import.meta.env.VITE_GATEWAY_API_BASE_URL ||
  import.meta.env.VITE_GATEWAY_URL ||
  import.meta.env.VITE_API_BASE_URL ||
  'http://localhost:8080';
const grammarServiceUrl =
  import.meta.env.VITE_GRAMMAR_SERVICE_URL ||
  'https://grammar-service-643676861437.asia-south1.run.app';

const serviceUrls = {
  gateway,
  platform: gateway,
  roster: gateway,
  learning: gateway,
  analytics: gateway,
  comms: gateway,
  billing: gateway,
  grammarServiceUrl,
} as const;

export type ServiceUrlKey = keyof typeof serviceUrls;

export { serviceUrls, gateway, grammarServiceUrl };
